import React, { Component, createRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ValorInput from "src/newDesign/components/valor-input";
import { hasLogin, hasPixParam, hasPreTicketParam, hasWalletParam, savePreTicket } from "../utils/getPreTickets";
import Moment from "moment";

import { PayButton } from "../common/cart/payButton";

//Actions
import {
  selectDezena,
  selectConcursoScreen,
  selectConcursosDate,
} from "../reducers/concurso/concursoActions";
import {
  addAposta,
  removeAposta,
  enviarAposta,
  removeETicket,
} from "../reducers/carrinho/carrinhoActions";
import {
  convertDate,
  convertIntegerToMoney,
  getDeviceType,
  getOrientation,
} from "../modules/helpers";
import { converteHorarioRodada } from "../loteria/utils/extracaoUtils";
import { repeatedAposta } from "../reducers/repeticao/repeticaoActions";
import Row from "../common/layout/row";
import Dropdown from "../common/form/labelAndDropdown";
import LabelInput from "../common/form/labelAndInput";
import LabelMoney from "../common/form/labelAndMoney";

import Cartela from "./concursoCartela";
import BilheteCard from "../common/bilheteCard/bilheteCard";

import "../common/template/dependencies";

import "./concurso.css";
import { toInteger } from "lodash";
import { Ticket } from "../rifa/components";
import DateSelector from "../newDesign/components/date-selector";
import getMaxPossiblePrize from "../newDesign/utils/getPremioMaximo";
import PixTicket from "../rifa/components/pixticket";
import { saveCart, getSavedCart, removeSavedCart } from "../modules/localStorage";
import { forceInt } from "../utils/forceInt";

const leftPad = require("left-pad");

// var CheckBoxList = require('react-checkbox-list');

class ConcursoInput extends Component {
  constructor(props) {
    super(props);

    // let datas = this.getDatasConcurso()

    this.state = {
      Aposta_ID: 0,
      dezenas: [],
      concursoMaxDezena: 0,
      possivelRetorno: "0,00",
      valorTotal: this.props.concursoType.objTipoJogo.numValorMinimoAposta
        ? this.props.concursoType.objTipoJogo.numValorMinimoAposta *
          (this.props.isNewDesign ? 1 : 100)
        : 0,
      minValue: this.props.concursoType.objTipoJogo.numValorMinimoAposta
        ? this.props.concursoType.objTipoJogo.numValorMinimoAposta *
          (this.props.isNewDesign ? 1 : 100)
        : 0,
      valorFixo: this.props.concursoType.objTipoJogo.numValorFixo
        ? this.props.concursoType.objTipoJogo.numValorFixo *
          (this.props.isNewDesign ? 1 : 100)
        : undefined,
      totalGeral: 0,
      datasConcursoSel: [],
      messageETicket: "",
      currentETicket: null,
      currentPixTicket: null,
      orientation: getOrientation(),
      showETicket: false,
      isPreTicket: false,
      ticketError: false,
      firstRendering: true,
      radioGroupName: "radio1",
      arrRepeticao: [],
      dateSelectorKey: 0,
      hasPreTicketParam: false,
      hasPixParam: false,
      hasWalletParam: false,
      hasLogin: false
    };

    this.atualizaPossivelRetorno = this.atualizaPossivelRetorno.bind(this);
    this.selectMaxDezenas = this.selectMaxDezenas.bind(this);
    this.componentWillMount = this.componentWillMount.bind(this);
    this.limparSelecao = this.limparSelecao.bind(this);
    this.surpresinha = this.surpresinha.bind(this);
    this.adicionaAposta = this.adicionaAposta.bind(this);
    this.apagaAposta = this.apagaAposta.bind(this);
    this.handleChkDatasChange = this.handleChkDatasChange.bind(this);
    this.doOnOrientationChange = this.doOnOrientationChange.bind(this);
    this.eTicketOK = this.eTicketOK.bind(this);
    this.apagaETicket = this.apagaETicket.bind(this);
    this.showETicketDetail = this.showETicketDetail.bind(this);
    this.goHome = this.goHome.bind(this);
    this.toggleETicketModal = this.toggleETicketModal.bind(this);
    this.newValorTotal = this.newValorTotal.bind(this);
    this.verificaFluxoRepeticao = this.verificaFluxoRepeticao.bind(this);
    this.createTransaction = this.createTransaction.bind(this);

    this.props.selectConcursosDate([]);

    this.topRef = this.props.topRef || createRef(null);
  }

  verificaFluxoRepeticao() {
    let id = 0;
    let total = 0;

    if (this.props.arrRepeticao && this.props.arrRepeticao.length > 0) {
      const arrRepeticao = this.props.arrRepeticao;
      var arrApostas = [];

      for (var i = 0; i < arrRepeticao.length; i++) {
        arrApostas.push({
          Aposta_ID: ++id,
          tipo: this.props.concursoType.objTipoJogo,
          valor: arrRepeticao[i].numValor * 100,
          numeros: arrRepeticao[i].arrNumero.sort(),
        });
        total += arrRepeticao[i].numValor * 100;
      }

      //Adicionar a aposta ao carrinho
      this.props.addAposta(arrApostas);
      saveCart(this.props.concursoType, arrApostas, 'concurso-cart');

      this.props.repeatedAposta({
        arrAposta: [],
      });

      this.setState({
        Aposta_ID: id,
        totalGeral: total,
      });

      this.limparSelecao();
    }
  }

  goHome() {
    this.props.selectConcursoScreen(0);
  }

  getDatasConcurso() {
    const arr = this.props.objUser.objConcursos.arrConcursos.filter(
      (e) => e.sntTipojogo === this.props.concursoType.objTipoJogo.sntTipoJogo
    );
    var datas = [];

    for (var i = 0; i < arr.length; i++) {
      // Replace é necessário por esse formato ter uma maior aceitação ex: safari
      const data = new Date(arr[i].sdtData.replace(/-/g, "/"));
      datas.push({ value: arr[i].sdtData, label: data.toLocaleDateString() });
    }

    return datas;
  }

  componentWillMount() {
    const listaDezenas = this.renderDezenasOptions(
      this.props.concursoType.lstTamanhoFixo
    );
    this.setState({
      dezenas: listaDezenas,
      hasPreTicketParam: hasPreTicketParam(),
      hasPixParam: hasPixParam(),
      hasWalletParam: hasWalletParam(),
      hasLogin: hasLogin(),
    });


    if (this.state.concursoMaxDezena == 0) {
      if (listaDezenas && listaDezenas[0] && listaDezenas[0].key) {
        const objTam = this.props.concursoType.lstTamanhoFixo.filter(
          (e) => e.tnyTamanho === listaDezenas[0].key
        );

        this.setState({
          concursoMaxDezena: listaDezenas[0].key / 2,
          maxValue:
            objTam && objTam.length
              ? objTam[0].numValorMaximoAposta
              : undefined,
        });
      }
    }

    const savedCart = getSavedCart(this.props.concursoType, 'concurso-cart');
    if (savedCart) {
      this.props.addAposta(savedCart);
    } else {
      this.props.addAposta([]);
    }

    this.props.selectDezena([]);

    if (this.props.eTickets.length <= 0) {
      this.setState({ messageETicket: "Não há jogos realizados" });
    }

    this.verificaFluxoRepeticao();

    window.addEventListener("orientationchange", this.doOnOrientationChange);
  }

  componentDidUpdate() {
    let backdrop = document.getElementsByClassName("backdrop")[0];
    let modalDialog = document.getElementsByClassName("modal-dialog")[0];
    if (!backdrop) return;
    if (!modalDialog) return;

    // Se o usuário clicar no diálogo do modal ele não deve fechar há não ser que seja o botão de fechar
    modalDialog.onclick = (event) => {
      if (event.srcElement.id === "closeModalBtn") return;

      event.stopPropagation();
    };

    // Fecha modal caso clique fora do modal
    backdrop.onclick = () => {
      this.toggleETicketModal();
    };
  }

  componentWillUnmount() {
    window.removeEventListener("orientationchange", this.doOnOrientationChange);
  }

  renderDezenasOptions(lstTamanhoFixo) {
    return lstTamanhoFixo.map((tip) => (
      <option key={tip.tnyTamanho} value={tip.tnyTamanho / 2}>{` ${
        tip.tnyTamanho / 2
      } paga ${tip.numValorPagoTamanhoFixo} x`}</option>
    ));
  }

  atualizaPossivelRetorno(rawValue, displayValue, concursoMaxDezena) {
    concursoMaxDezena = concursoMaxDezena
      ? concursoMaxDezena
      : this.state.concursoMaxDezena;
    const maxD = concursoMaxDezena * 2;
    const objTam = this.props.concursoType.lstTamanhoFixo.filter(
      (e) => e.tnyTamanho === maxD
    );

    //Calcula o possível retorno de acordo com a lista de premios fixos.
    const pRet = rawValue * (objTam[0] ? objTam[0].numValorPagoTamanhoFixo : 0);

    this.setState({
      possivelRetorno: convertIntegerToMoney(pRet),
      valorTotal: rawValue,
    });
  }

  selectMaxDezenas(obj) {
    this.props.selectDezena([]);

    const objTam = this.props.concursoType.lstTamanhoFixo.filter(
      (e) => e.tnyTamanho === obj.target.value * 2
    );

    this.setState({
      concursoMaxDezena: obj.target.value,
      maxValue:
        objTam && objTam.length ? objTam[0].numValorMaximoAposta : undefined,
      // valorTotal: this.state,
      concursoQtdDezenasSel: 0,
      possivelRetorno: "",
    });
    this.atualizaPossivelRetorno(this.state.valorTotal, null, obj.target.value);
  }

  limparSelecao() {
    if (this.props.eTickets.length <= 0) {
      this.setState({ messageETicket: "Não há jogos realizados" });
    }

    this.props.selectDezena([]);

    this.setState({ concursoQtdDezenasSel: 0 });
  }

  surpresinha() {
    this.limparSelecao();

    var arrSurpresa = [];
    while (arrSurpresa.length < this.state.concursoMaxDezena) {
      var number = Math.floor(
        Math.random() * this.props.concursoType.objTipoJogo.tnyNumeroMax + 1
      );
      if (number == 0) number = 1;

      number = leftPad(number, 2, 0);

      const exists = arrSurpresa.some((item) => item === number);

      if (!exists) {
        arrSurpresa.push(number);
      }
    }

    this.props.selectDezena(arrSurpresa);
  }

  adicionaAposta() {
    const value =
      this.state.valorTotal <
      this.state.minValue
        ? this.state.minValue
        : this.state.valorTotal;

    const objTam = this.props.concursoType.lstTamanhoFixo.filter(
      (e) => e.tnyTamanho === this.state.concursoMaxDezena * 2
    );

    //Validar a aposta corrente.
    if (
      value / 100 <
      this.props.concursoType.objTipoJogo.numValorMinimoAposta
    ) {

      this.props.toggleErrorModal("Aposta Inválida", "Valor da Aposta inválida.");
    } else if (this.props.qtdDezenasSel != this.state.concursoMaxDezena) {
      this.props.toggleErrorModal("Aposta Inválida", "Quantidade incorreta de dezenas selecionadas.");
    } else if (value / 100 > objTam[0].numValorMaximoAposta) {
      this.props.toggleErrorModal("Aposta Inválida",
      "Valor da aposta não pode ser maior que: ".concat(
        objTam[0].numValorMaximoAposta
      ));
    } else {
      var arrApostas = this.props.arrApostas;
      var Aposta_ID = this.state.Aposta_ID + 1;

      arrApostas.push({
        Aposta_ID: Aposta_ID,
        tipo: this.props.concursoType.objTipoJogo,
        valor: value,
        numeros: this.props.dezenasSel.sort(),
      });

      //Adicionar a aposta ao carrinho
      this.props.addAposta(arrApostas);
      saveCart(this.props.concursoType, arrApostas, 'concurso-cart');

      this.setState({
        Aposta_ID: Aposta_ID,
        totalGeral: this.state.totalGeral + value,
      });

      this.limparSelecao();

      const totalGeral = this.newValorTotal(
        this.props.datasConcursoSel,
        value,
        this.props.arrApostas
      );

      if (totalGeral !== undefined) {
        this.setState({
          totalGeral: totalGeral,
        });
      }
    }
  }

  apagaAposta(Aposta_ID, valorAposta) {
    this.props.removeAposta(Aposta_ID);
      saveCart(this.props.concursoType, this.props.arrApostas, 'concurso-cart');
    this.setState({
      totalGeral:
        this.state.totalGeral -
        valorAposta * this.props.datasConcursoSel.length,
    });
  }

  handleChkDatasChange(datasConcurso) {
    const totalGeral = this.newValorTotal(
      datasConcurso,
      this.state.valorTotal,
      this.props.arrApostas
    );

    this.props.selectConcursosDate(datasConcurso);
    if (totalGeral !== undefined) {
      this.setState({
        totalGeral: totalGeral,
      });
    }

    // this.setState({datasConcurso: values})
  }

  newValorTotal(datasConcurso, currentValorTotal, arrApostas) {
    if (arrApostas != undefined && arrApostas.length > 0) {
      var qtdConcursos = datasConcurso.length;
      return (
        arrApostas.reduce((sum, aposta) => {
          return sum + aposta.valor;
        }, 0) * qtdConcursos
      );
    } else {
      return undefined;
    }
  }

  renderCarrinho() {
    let getPossivelRetorno = (length) => {
      let objTamFixo = this.props.concursoType.lstTamanhoFixo.filter(
        (e) => e.tnyTamanho === length * 2
      )[0];
      return objTamFixo ? objTamFixo.numValorPagoTamanhoFixo : 0;
    };
    
    return this.props.arrApostas.map((ap) => (
      <li className="list-group-item" id={ap.Aposta_ID} key={ap.Aposta_ID}>
        <div className="carrinho_row">
          <table>
            <tbody>
              <tr>
                <td rowSpan="2">
                  <div className="smallCircle">
                    <p>{leftPad(ap.Aposta_ID, 2, 0)}</p>
                  </div>
                </td>
                <td>
                  <span className="info">{` ${
                    ap.tipo.vchNome
                  } a R$ ${convertIntegerToMoney(ap.valor)} com ${
                    ap.numeros.length
                  } dezenas (${getPossivelRetorno(ap.numeros.length)}x)`}</span>
                </td>
                <td rowSpan="2">
                  <a
                    href="javascript:;"
                    onClick={() => this.apagaAposta(ap.Aposta_ID, ap.valor)}
                  >
                    <i className="fa fa-trash"></i>
                  </a>
                </td>
              </tr>
              <tr>
                <td>
                  <span>{ap.numeros.join("-")}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </li>
    ));
  }

  doOnOrientationChange() {
    var mql = window.matchMedia("(orientation: landscape)");

    if (mql.matches) {
      this.setState({ orientation: "portrait" });
    } else {
      this.setState({ orientation: "landscape" });
    }
  }

  overlay() {
    if (this.props.isFetching) {
      return (
        <div className="overlay">
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      );
    }

    return <div></div>;
  }

  apagaETicket(eTicket) {
    this.props.removeETicket(eTicket);
    this.limparSelecao();
  }

  showETicketDetail(eTicket) {
    this.setState({ currentETicket: eTicket });
  }

  renderConcursos(ETicket) {
    /**
     * Visto que a estrutura dos dados Para a a geração do card de bilhete não são Uniformes
     * a longo da aplicação, se torna necessário mapear para uma estrutura aceita pelo componente
     */

    let getPossivelRetorno = (length) => {
      return this.props.concursoType.lstTamanhoFixo.filter(
        (e) => e.tnyTamanho === length * 2
      )[0].numValorPagoTamanhoFixo;
    };

    let arrJogo = ETicket.detail.Carrinho.map((ap) => {
      return {
        arrNumeros: ap.numeros,
        valor: ap.valor,
        nome: ap.tipo.vchNome,
        possivelRetorno: getPossivelRetorno(ap.numeros.length),
      };
    });

    let arrBilhete = ETicket.detail.arrExtracaoData.map((ap, i) => {
      return {
        numValorApostas: ETicket.detail.numValorApostas,
        vchNome: ETicket.detail.Carrinho[0].tipo.vchNome,
        sntTipoJogo: ETicket.detail.arrApostas[0].sntTipoJogo,
        sdtDataHora: ETicket.detail.sdtDataHora.toLocaleString(),
        vchETicket: ETicket.arrETicket[i],
        intNumeroPule: ETicket.arrIntNumeroPule[i],
        vchCodigoSeguranca: ETicket.arrCodigoSeguranca[i],
        chrSerial: this.props.objUser.ChrSerial,
        sdtDataJogo: ap.sdtData,
        arrJogo: arrJogo,
        vcHorarioSorteio: ap.vcHorarioSorteio,
        bitConcurso: ETicket.detail.bitConcurso,
      };
    });

    return (
      <div>
        {arrBilhete.map((Bilhete, i) => (
          <BilheteCard Bilhete={Bilhete} flatTop={i === 0 ? true : false} />
        ))}
      </div>
    );
  }

  renderTicket(ETicket, isPreTicket = false) {
    /**
     * Visto que a estrutura dos dados Para a a geração do card de bilhete não são Uniformes
     * a longo da aplicação, se torna necessário mapear para uma estrutura aceita pelo componente
     */

    let getPossivelRetorno = (length) => {
      return this.props.concursoType.lstTamanhoFixo.find(
        (e) => e.tnyTamanho === length * 2
      ).numValorPagoTamanhoFixo;
    };

    const arrJogo = ETicket.detail.Carrinho.map((ap) => {
      const maxPrize = getMaxPossiblePrize(
        this.props.concursoType,
        ap.numeros.length
      );
      const possivelRetorno =
        getPossivelRetorno(ap.numeros.length) * (ap.valor / 100);
      return {
        arrNumeros: ap.numeros,
        valor: ap.valor,
        nome: ap.tipo.vchNome,
        possivelRetorno: maxPrize
          ? Math.min(possivelRetorno, maxPrize)
          : possivelRetorno,
      };
    });

    const maxPrize = getMaxPossiblePrize(this.props.concursoType);

    const possiblePrize = arrJogo.reduce(
      (sum, item) => item.possivelRetorno + sum,
      0
    );

    const prize = maxPrize ? Math.min(possiblePrize, maxPrize) : possiblePrize;

    const arrBilhetes = ETicket.detail.arrExtracaoData.map((ap, i) => {
      return {
        bets: undefined,
        value: ETicket.detail.numValorApostas,
        date: ETicket.detail.sdtDataHora.toLocaleString(),
        prize: prize,
        extraction: undefined,
        concurso: `${convertDate(ap.sdtData)} ${
          ap.vcHorarioSorteio.length > 0 ? ap.vcHorarioSorteio : ""
        }`,
        venda: isPreTicket ? null : ETicket.arrETicket[i],
        name: ETicket.detail.Carrinho[0].tipo.vchNome,
        image: undefined,
        arrJogo: arrJogo,
        isLoteria: !ETicket.detail.bitConcurso,
        intNumeroPule: isPreTicket ? null : ETicket.arrIntNumeroPule[i],
        vchCodigoSeguranca: isPreTicket ? null : ETicket.arrCodigoSeguranca[i],
        chrSerial: this.props.objUser.ChrSerial,
        maxDate: `${Moment(ap.sdtData).format("DD/MM/YYYY")}`,
      };
    });
    if(isPreTicket) savePreTicket({bilhetes: arrBilhetes, preTicket: ETicket.vchPreTicket});
    return <Ticket bilhetes={arrBilhetes} onClose={this.toggleETicketModal} preTicket={ETicket.vchPreTicket}/>;
  }

  renderEticketModal(ETicket) {
    return (
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => this.toggleETicketModal()}
            >
              <span id="closeModalBtn" aria-hidden="true">
                X
              </span>
            </button>
          </div>
        </div>
        {this.renderConcursos(ETicket)}
      </div>
    );
  }

  getCarrinhoDetails(arrJogo) {
    let bitSuasApostas = false;

    return (
      <div>
        {arrJogo.map((ap) => {
          return (
            <div key={ap.Aposta_ID}>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <b>{` ${ap.nome} a R$ ${convertIntegerToMoney(
                        ap.valor
                      )}  com ${ap.arrNumeros.length} dezenas (paga ${
                        ap.possivelRetorno
                      }x)`}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>{ap.arrNumeros.join("-")}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          );
        })}
      </div>
    );
  }

  eTicketOK(eTicket, isPreTicket = false, isPix = false) {
    if (eTicket) {
      this.limparSelecao();
    }

    this.props.addAposta([]);
    this.props.selectConcursosDate([]);
    removeSavedCart('concurso-cart');

    this.setState({
      Aposta_ID: 0,
      possivelRetorno: "0,00",
      valorTotal: this.props.concursoType.objTipoJogo.numValorMinimoAposta
        ? this.props.concursoType.objTipoJogo.numValorMinimoAposta * 100
        : 0,
      totalGeral: 0,
      messageETicket:
        this.props.eTickets.length <= 0 ? "Não há jogos realizados" : "",
      currentETicket: !isPix ? eTicket: null,
      currentPixTicket: isPix ? eTicket: null,
      showETicket: true,
      isPreTicket,
      dateSelectorKey: this.state.dateSelectorKey + 1,
    });

    var isChecked = document.querySelector(
      `input[name="${this.state.radioGroupName}"]:checked`
    );

    if (!!isChecked) {
      isChecked.checked = false;
    }
    var lstChk = document.getElementsByClassName("checkPremio");
    for (var i = 0; i <= lstChk.length - 1; i++) {
      lstChk[i].checked = false;
    }

    lstChk = document.getElementsByClassName(this.state.radioGroupName);
    for (var i = 0; i <= lstChk.length - 1; i++) {
      lstChk[i].checked = false;
    }
  }

  toggleETicketModal() {
    this.setState({
      showETicket: !this.state.showETicket,
    });
  }

  createTransaction(isPreTicket = false, isPix = false) {
    var arrData = [];
    var arrAposta = [];
    var transaction = {};

    if (this.props.datasConcursoSel.length < 1) {
      this.props.toggleErrorModal("Aposta Inválida", "Favor selecionar ao menos uma data de concurso.");
      return;
    } else {
      var concursoDiario = this.props.objUser.objConcursos.arrConcursos; //.filter((e) => (e.sntTipojogo === this.props.concursoType.objTipoJogo.sntTipoJogo));
      var concursoRodada = this.props.objUser.objConcursos.arrConcursosGame; //.filter((e) => (e.sntTipojogo === this.props.concursoType.objTipoJogo.sntTipoJogo));

      var concurso = concursoRodada
        .concat(concursoDiario)
        .filter(
          (e) =>
            e.sntTipojogo === this.props.concursoType.objTipoJogo.sntTipoJogo
        );
      var arrConcursoData = [...this.props.datasConcursoSel];

      for (var i = 0; i < arrConcursoData.length; i++) {
        var data = {
          tnyExtracao: concurso[0].tnyExtracao,
          sntConcurso: concurso[0].sntConcurso,
          intNumeroSorteio: concurso[0].intNumeroConcurso,
          sdtData: "",
          ConcursoData_ID: 0,
          vcHorarioSorteio: "",
        };

        if (
          concurso[0].arrConcursoSorteio &&
          concurso[0].arrConcursoSorteio.length > 0 &&
          concurso[0].arrConcursoSorteio[0].intHorarioRodada > 0
        ) {
          const getContestDrawTime = () => {
            let concursoData_ID = toInteger(arrConcursoData[i]);

            data.ConcursoData_ID = concursoData_ID;
            data.sdtData = concurso[0].sdtData;

            let intHorarioRodada = concurso[0].arrConcursoSorteio.filter(
              (c) => c.ConcursoData_ID === concursoData_ID
            )[0].intHorarioRodada;

            const returnedValue = converteHorarioRodada(intHorarioRodada);
            if (!isPix) return returnedValue;

            const pixMinDate = new Date(Date.now() + (5 * 60 + 10) * 1000);

            const date = new Date(data.sdtData);
            const [hours, minutes] = returnedValue.split(":").map(digits => Number(digits) || 0);
            date.setHours(hours);
            date.setMinutes(minutes); 

            if (date < pixMinDate) {
              for (let j = i; j < arrConcursoData.length; j++) {
                arrConcursoData[j] ++;
              }
              return getContestDrawTime();
            }

            return returnedValue;
          }

          data.vcHorarioSorteio = getContestDrawTime();
        } else {
          data.sdtData = arrConcursoData[i].date;
          data.ConcursoData_ID = arrConcursoData[i].id;
        }

        arrData.push(data);
      }

      transaction.intNumeroConcurso = concurso[0].sntConcurso;

      var numValorTotal = 0;
      for (var i = 0; i < this.props.arrApostas.length; i++) {
        var apostaCorrente = this.props.arrApostas[i];
        var aposta = {
          sntTipoJogo: this.props.concursoType.objTipoJogo.sntTipoJogo,
          vchNumero: apostaCorrente.numeros.join(""),
          vchPremio: this.props.concursoType.lstPremioFixo[0]
            ? this.props.concursoType.lstPremioFixo[0].vchPremioFixo
            : 1,
          numValor: apostaCorrente.valor / 100,
          numValorTotal: apostaCorrente.valor / 100,
        };

        numValorTotal += apostaCorrente.valor;
        arrAposta.push(aposta);
      }

      transaction.Cliente_ID = this.props.objUser.Cliente_ID;
      transaction.Site_ID = forceInt(this.props.objUser.Site_ID);
      transaction.CID = this.props.objUser.CID;
      transaction.chrSerial = this.props.objUser.ChrSerial;
      transaction.Session_ID = this.props.objUser.Session_ID;
      transaction.strToken = this.props.objUser.TokenLE;
      transaction.sdtDataHora = new Date();
      transaction.arrExtracaoData = arrData;
      transaction.arrApostas = arrAposta;
      transaction.Carrinho = this.props.arrApostas;
      transaction.numValorApostas = numValorTotal / 100;
      transaction.sntQuantidadeApostas = arrAposta.length;
      transaction.valorTotal = numValorTotal;
      transaction.bitConcurso = this.props.concursoType.objTipoJogo.bitConcurso;

      this.props.enviarAposta(transaction, this.eTicketOK, isPreTicket, isPix, (title,message)=>{this.props.toggleErrorModal(title, message)});
    }
  }

  renderPixTicket(ETicket) {
    let getPossivelRetorno = (length) => {
      return this.props.concursoType.lstTamanhoFixo.find(
        (e) => e.tnyTamanho === length * 2
      ).numValorPagoTamanhoFixo;
    };

    const arrJogo = ETicket.detail.Carrinho.map((ap) => {
      const maxPrize = getMaxPossiblePrize(
        this.props.concursoType,
        ap.numeros.length
      );
      const possivelRetorno =
        getPossivelRetorno(ap.numeros.length) * (ap.valor / 100);
      return {
        arrNumeros: ap.numeros,
        valor: ap.valor,
        nome: ap.tipo.vchNome,
        possivelRetorno: maxPrize
          ? Math.min(possivelRetorno, maxPrize)
          : possivelRetorno,
      };
    });

    const maxPrize = getMaxPossiblePrize(this.props.concursoType);

    const possiblePrize = arrJogo.reduce(
      (sum, item) => item.possivelRetorno + sum,
      0
    );

    const prize = maxPrize ? Math.min(possiblePrize, maxPrize) : possiblePrize;

    const arrBilhetes = ETicket.detail.arrExtracaoData.map((ap, i) => {
      return {
        value: ETicket.detail.numValorApostas,
        date: ETicket.detail.sdtDataHora.toLocaleString(),
        prize: prize,
        concurso: `${convertDate(ap.sdtData)} ${
          ap.vcHorarioSorteio.length > 0 ? ap.vcHorarioSorteio : ""
        }`,
        name: ETicket.detail.Carrinho[0].tipo.vchNome,
        arrJogo: arrJogo,
        isLoteria: !ETicket.detail.bitConcurso
      };
    });

    const ticket = {
      bilhetes: arrBilhetes,
      timestamp: Date.now(),
      objTipoJogo: this.props.concursoType.objTipoJogo,
      ...ETicket
    };

    return <PixTicket ticket={ticket} onClose={this.toggleETicketModal} toggleErrorModal={this.props.toggleErrorModal} />;
  }

  render() {
    var hddClass = getDeviceType() == "desktop" ? "hiddenObject" : "";
    var hddTotal = this.state.totalGeral > 0 ? "" : "hiddenObject";
    var hddClassBtnTotal =
      getDeviceType() != "desktop" &&
      this.state.totalGeral > 0 &&
      this.props.datasConcursoSel.length > 0
        ? ""
        : "hiddenObject";

    var isLandscape = this.props.orientation === "landscape";
    var pullRight = isLandscape ? "" : "pull-right";

    return (
      <div className="concurso-input-container">
        <section className="row" style={{ paddingLeft: "15px" }}>
          <section className="col-md-12 modalidade-input-container-title">
            <h3>{this.props.concursoType.objTipoJogo.vchNome}</h3>
          </section>
        </section>
        <section className="col-md-7 cartela-container">
          <div className="box box-solid">
            <div
              className="box-header with-border"
              style={{ paddingBottom: "0px" }}
            >
              <div className="no row">
                <div className="col-md-9 nopadding">
                  <Dropdown
                    name="ddlDezenas"
                    cols="12 12 12"
                    label={
                      (isLandscape ? "Quantidade de" : "Qtde") + " Dezenas"
                    }
                    onChange={this.selectMaxDezenas}
                  >
                    {this.state.dezenas}
                  </Dropdown>
                </div>
                <div className="col-md-3 nopadding">
                  <span
                    className="box-title"
                    style={{
                      float: "right",
                      margin: "10px",
                      fontSize: "15px",
                      marginLeft: "0px",
                    }}
                  >
                    Dezenas -{" "}
                    {`${this.props.qtdDezenasSel} de ${this.state.concursoMaxDezena}`}{" "}
                  </span>
                </div>
              </div>
            </div>
            <div className="box-body">
              <div className="row">
                <Cartela
                  cols="12 12 12"
                  maxDezenas={this.state.concursoMaxDezena}
                  orientation={this.state.orientation}
                  onRef={(ref) => (this.cartela = ref)}
                />
              </div>
            </div>
            {this.props.isNewDesign ? (
              <div className="valor-aposta-concurso">
                <div>
                  <ValorInput
                    title="Valor Aposta"
                    value={this.state.valorTotal}
                    onChange={this.atualizaPossivelRetorno}
                    minValue={this.state.valorFixo || this.state.minValue}
                    maxValue={this.state.valorFixo || this.state.maxValue}
                  />
                </div>
                <div className="possivel-premio-concurso">
                  <label>Possível Retorno</label>
                  <p>R$ {this.state.possivelRetorno}</p>
                </div>
              </div>
            ) : (
              <div
                className="box-body "
                style={{ borderTop: "1px solid #f4f4f4", marginTop: "5px" }}
              >
                <div className="row ">
                  <div
                    className={
                      "col-md-6 col-sm-12 col-xs-12" +
                      (isLandscape ? " nopadding" : "")
                    }
                    style={{ marginTop: "5px", paddingLeft: "0" }}
                  >
                    <LabelMoney
                      id="numValor"
                      label="Valor Aposta"
                      orientation={this.state.orientation}
                      cols="12 12 12"
                      value={this.state.valorTotal}
                      onChange={this.atualizaPossivelRetorno}
                      onBlur={() => {
                        const value =
                          this.state.valorTotal < this.state.minValue
                            ? this.state.minValue
                            : this.state.valorTotal;
                        this.atualizaPossivelRetorno(value);
                      }}
                    />
                  </div>
                  <div
                    className="col-md-6 col-sm-12 col-xs-12"
                    style={{ marginTop: "5px", paddingLeft: "0" }}
                  >
                    <LabelInput
                      label="Possível Retorno"
                      orientation={this.state.orientation}
                      text={this.state.possivelRetorno}
                      readOnly="true"
                      cols="12 12 12"
                    />
                  </div>
                </div>
                <div className="row"></div>
              </div>
            )}
            <div
              className="box-footer box-footer-concurso"
              style={
                this.state.orientation == "landscape"
                  ? { paddingLeft: "50px", paddingRight: "50px" }
                  : {}
              }
            >
              <Row>
                <div className="col-xs-12">
                  <button
                    type="button"
                    className={`btn btn-success ${pullRight}`}
                    onClick={this.adicionaAposta}
                  >
                    Adicionar
                  </button>
                  <button
                    type="button"
                    className={`btn btn-primary ${pullRight}`}
                    onClick={this.surpresinha}
                  >
                    Surpresa
                  </button>
                  <button
                    type="button"
                    className={`btn ${pullRight}`}
                    onClick={this.limparSelecao}
                  >
                    Limpar
                  </button>
                  <a
                    className={`btn btn-danger ${pullRight} new-design-display-none`}
                    onClick={this.goHome}
                  >
                    Voltar
                  </a>
                </div>
              </Row>
            </div>
          </div>
        </section>
        <section className="col-md-5">
          <div className="box box-solid with-border">
            <div className="box-header">
              <span className="box-title">Suas apostas</span>
            </div>
            <div className="box-body">
              <ul className="list-group list-group-flush">
                {this.renderCarrinho()}
              </ul>
              <div className="col-xs-12">
                <DateSelector
                    handleChange={this.handleChkDatasChange}
                    selectedContest={this.props.concursoType}
                    key={this.state.dateSelectorKey}
                  />
              </div>
            </div>

            <PayButton 
                gameType="concurso"
                hasLogin={this.state.hasLogin}
                hasPix={this.state.hasPixParam}
                hasPreTicket={this.state.hasPreTicketParam}
                hasWallet={this.state.hasWalletParam}
                totalValue={this.state.totalGeral}
                createTransaction={this.createTransaction}
            />

            {/* <div className="box-footer with-border">
              <Row>
                <div className="col-xs-12">
                  {(this.state.totalGeral > 0 && 
                  this.state.hasWalletParam) &&
                    <button
                      type="button"
                      className={`btn btn-primary pull-right submit-button ${hddTotal}`}
                      onClick={() => this.createTransaction(false, false)}
                    >
                      + Finalizar{this.state.totalGeral > 0 && ` - R$ ${convertIntegerToMoney(this.state.totalGeral)}`}
                    </button>
                  }
                </div>
              </Row>
              <Row>
                <div className="col-xs-12">
                {(this.state.totalGeral > 0 && 
                this.state.hasPixParam && 
                this.state.hasLogin) &&
                  <div className="col-xs-12">
                    <button
                      type="button"
                      className={`btn btn-primary pull-right submit-button ${hddTotal}`}
                      onClick={() => this.createTransaction(false, true)}
                    >
                      Pagar Agora!{this.state.totalGeral > 0 && ` - R$ ${convertIntegerToMoney(this.state.totalGeral)}`}
                    </button>
                  </div>
                }
                </div>
              </Row>
              {this.state.hasPreTicketParam &&
                <Row>
                  <div className="col-xs-12">
                    <button
                      type="button"
                      className={`btn btn-primary pull-right submit-button ${hddTotal}`}
                      onClick={() => this.createTransaction(true, false)}
                    >
                      Gerar pre-ticket
                    </button>
                  </div>
                </Row>
              }
            </div> */}

            {this.overlay()}
          </div>
        </section>
        {this.state.currentETicket && this.state.showETicket &&
          this.renderTicket(this.state.currentETicket, this.state.isPreTicket)
        }
        {this.state.currentPixTicket && this.state.showETicket &&
          this.renderPixTicket(this.state.currentPixTicket)
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    objUser: state.usuario.objUser,
    concursoScreen: state.concurso.concursoScreen,
    concursoType: state.concurso.concursoType,
    dezenasSel: state.concurso.dezenasSel,
    qtdDezenasSel: state.concurso.qtdDezenasSel,
    arrApostas: state.carrinho.arrApostas,
    isFetching: state.carrinho.isFetching,
    eTickets: state.carrinho.eTickets,
    datasConcursoSel: state.concurso.datasConcursoSel,
    ticketError: state.carrinho.ticketError,
    arrRepeticao: state.repeticao.arrAposta,
    isNewDesign: state.settings.isNewDesign,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      selectDezena,
      addAposta,
      removeAposta,
      enviarAposta,
      removeETicket,
      selectConcursoScreen,
      selectConcursosDate,
      repeatedAposta,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(ConcursoInput);



// WEBPACK FOOTER //
// ./src/concurso/concursoInput.jsx